import { render, staticRenderFns } from "./ProBanner.vue?vue&type=template&id=077a0022&"
import script from "./ProBanner.vue?vue&type=script&lang=ts&"
export * from "./ProBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports